export const translations = {
  es: {
    nav: { model: "Modelo", components: "Impacto", neuroscience: "Fundamento", login: "Ingresar" },
    hero: {
      label: "Transformación del aprendizaje",
      title_1: "EL FUTURO",
      title_2: "ES HOY",
      subtitle_1_a: "La educación ya está evolucionando.",
      subtitle_1_b: "Y hoy es posible acompañar el aprendizaje de cada estudiante con precisión, claridad y propósito.",
      cta: "Solicitar piloto",
    },
    declaration: {
      label: "¿Qué es QHUB.BUDDY?",
      text_pre: "El modelo Educativo adaptativo impulsado por inteligencia Artificial que acompaña el aprendizaje de forma",
      text_bold: "estructurada, progresiva, medible y segura.",
      sub: "Diseñado para actuar junto al docente, no en lugar de él.",
      pillars: [
        { label: "Personalización", desc: "El ritmo y el camino de cada estudiante son únicos." },
        { label: "Evidencia", desc: "Cada avance queda registrado como información real." },
        { label: "Decisión", desc: "La información impulsa acciones pedagógicas concretas." },
        { label: "Gamificación", desc: "Logros, puntos y retos que mantienen la motivación activa." },
      ],
    },
    transformation: {
      label: "Una experiencia diferente",
      title: "",
      items: [
        { n: "01", title: "Aprende a su ritmo", desc: "Cada estudiante avanza según su nivel, sin presión y sin límites artificiales." },
        { n: "02", title: "Refuerza lo visto en clase", desc: "El contenido trabaja en conjunto con el currículo, consolidando lo aprendido." },
        { n: "03", title: "Avanza progresivamente", desc: "Cada interacción construye sobre la anterior, generando un progreso real y sostenido." },
      ],
    },
    how: {
      label: "El proceso",
      title: "Cómo funciona",
      steps: [
        { n: "1", title: "Interacción", desc: "El estudiante trabaja el contenido de forma activa." },
        { n: "2", title: "Desarrollo", desc: "Avanza con ejercicios progresivos adaptados a su nivel." },
        { n: "3", title: "Evidencia", desc: "Cada respuesta queda registrada como dato de aprendizaje." },
        { n: "4", title: "Visualización", desc: "El progreso se convierte en información clara y accionable." },
      ],
    },
    visibility: {
      label: "Lo que se puede ver",
      title: "El progreso ya no es una percepción.",
      subtitle: "Es información clara.",
      items: [
        { title: "Progreso individual", desc: "Visibilidad del avance de cada estudiante en tiempo real." },
        { title: "Rendimiento grupal", desc: "Comprensión del comportamiento colectivo del grupo." },
        { title: "Identificación de brechas", desc: "Detección precisa de fortalezas y áreas de mejora." },
      ],
      quote: "\"El aprendizaje se vuelve visible, medible y accionable.\"",
    },
    actors: {
      label: "Impacto",
      title: "Un cambio real para cada actor educativo.",
      list: [
        { role: "Institución", lines: ["Toma decisiones pedagógicas con datos reales.", "Visibilidad del desempeño de todos sus grupos en un solo lugar."] },
        { role: "Docente", lines: ["Accede a evidencia del refuerzo fuera del aula.", "Recibe sugerencias pedagógicas orientadas al avance del grupo."] },
        { role: "Estudiante", lines: ["Avanza a su propio ritmo con retroalimentación continua.", "Cada interacción tiene un propósito y genera valor."] },
        { role: "Familia", lines: ["Sigue el progreso de sus hijos con claridad.", "Mantiene conexión con el proceso de aprendizaje en todo momento."] },
      ],
    },
    differential: {
      title_1: "Diseñado con",
      title_2: "responsabilidad.",
      subtitle: "La seguridad de cada estudiante es parte del modelo, no un añadido.",
      items: [
        "Consentimiento parental obligatorio",
        "Datos protegidos y cifrados",
        "Control de acceso por roles",
        "Principios internacionales de protección de datos",
      ],
    },
    finalcta: {
      label: "EL FUTURO ES HOY",
      title_1: "Activa la transformación",
      title_2: "del aprendizaje.",
      subtitle: "Únete a las instituciones que ya están acompañando a cada estudiante con precisión y propósito.",
      cta: "Solicitar piloto",
    },
    science: {
      title: "Fundamentación Neurocognitiva",
      subtitle: "Basado en teorías del aprendizaje, psicología cognitiva y principios neurocientíficos.",
      theory_title: "Fundamentos Teóricos",
      theories: [
        { author: "Piaget", concept: "Desarrollo cognitivo" },
        { author: "Vygotsky", concept: "Zona de desarrollo próximo" },
        { author: "Gardner", concept: "Inteligencias múltiples" },
        { author: "Flavell", concept: "Metacognición" },
      ],
      principles_title: "Principios Neurocognitivos Aplicados",
      principles: [
        "Aprendizaje espaciado",
        "Carga cognitiva",
        "Retroalimentación",
        "Andamiaje cognitivo",
        "Zona de desarrollo",
        "Activación de la metacognición",
      ],
    },
    levels: {
      title: "Niveles de implementación",
      subtitle: "Diseñado para estudiantes de 4° grado a 2° año de bachillerato",
      grades: [
        { grade: "4°", label: "Cuarto" },
        { grade: "5°", label: "Quinto" },
        { grade: "6°", label: "Sexto" },
        { grade: "7°", label: "Séptimo" },
        { grade: "8°", label: "Octavo" },
        { grade: "9°", label: "Noveno" },
        { grade: "1°", label: "Bachillerato" },
        { grade: "2°", label: "Bachillerato" },
      ],
      badge: "Progresión continua y adaptativa",
    },
    footer: {
      slogan: "Red Neuronal de Aprendizaje",
      tagline: "Basado en evidencia pedagógica y científica",
    },
  },
  en: {
    nav: { model: "Model", components: "Impact", neuroscience: "Foundation", login: "Sign In" },
    hero: {
      label: "Learning Transformation",
      title_1: "THE FUTURE",
      title_2: "IS NOW",
      subtitle_1_a: "Education is already evolving.",
      subtitle_1_b: "Today it is possible to support every student's learning with precision, clarity, and purpose.",
      cta: "Request a pilot",
    },
    declaration: {
      label: "What is QHUB.BUDDY?",
      text_pre: "The adaptive Educational model powered by Artificial Intelligence that accompanies learning in a",
      text_bold: "structured, progressive, measurable, and safe way.",
      sub: "Designed to work alongside the teacher, not in place of them.",
      pillars: [
        { label: "Personalization", desc: "Each student's pace and path are unique." },
        { label: "Evidence", desc: "Every advance is recorded as real learning data." },
        { label: "Decision", desc: "Information drives concrete pedagogical actions." },
        { label: "Gamification", desc: "Achievements, points and challenges that keep motivation alive." },
      ],
    },
    transformation: {
      label: "A different experience",
      title: "",
      items: [
        { n: "01", title: "Learn at their own pace", desc: "Each student advances at their level, without pressure or artificial limits." },
        { n: "02", title: "Reinforces classroom learning", desc: "Content works together with the curriculum, consolidating what was learned." },
        { n: "03", title: "Advances progressively", desc: "Each interaction builds on the previous one, generating real and sustained progress." },
      ],
    },
    how: {
      label: "The process",
      title: "How it works",
      steps: [
        { n: "1", title: "Interaction", desc: "The student works with content in an active way." },
        { n: "2", title: "Development", desc: "Advances with progressive exercises adapted to their level." },
        { n: "3", title: "Evidence", desc: "Each response is recorded as learning data." },
        { n: "4", title: "Visualization", desc: "Progress becomes clear and actionable information." },
      ],
    },
    visibility: {
      label: "What can be seen",
      title: "Progress is no longer a perception.",
      subtitle: "It is clear information.",
      items: [
        { title: "Individual progress", desc: "Visibility of each student's advancement in real time." },
        { title: "Group performance", desc: "Understanding the collective behavior of the group." },
        { title: "Gap identification", desc: "Precise detection of strengths and areas for improvement." },
      ],
      quote: "\"Learning becomes visible, measurable, and actionable.\"",
    },
    actors: {
      label: "Impact",
      title: "A real change for every educational stakeholder.",
      list: [
        { role: "Institution", lines: ["Makes pedagogical decisions with real data.", "Visibility of all group performance in one place."] },
        { role: "Teacher", lines: ["Access to evidence of out-of-classroom reinforcement.", "Receives pedagogical suggestions aimed at group progress."] },
        { role: "Student", lines: ["Advances at their own pace with continuous feedback.", "Every interaction has a purpose and generates value."] },
        { role: "Family", lines: ["Follows their children's progress with clarity.", "Stays connected to the learning process at all times."] },
      ],
    },
    differential: {
      title_1: "Designed with",
      title_2: "responsibility.",
      subtitle: "The safety of every student is part of the model, not an afterthought.",
      items: [
        "Mandatory parental consent",
        "Protected and encrypted data",
        "Role-based access control",
        "International data protection principles",
      ],
    },
    finalcta: {
      label: "THE FUTURE IS NOW",
      title_1: "Activate the transformation",
      title_2: "of learning.",
      subtitle: "Join the institutions already accompanying every student with precision and purpose.",
      cta: "Request a pilot",
    },
    science: {
      title: "Neurocognitive Foundation",
      subtitle: "Based on learning theories, cognitive psychology, and neuroscientific principles.",
      theory_title: "Theoretical Foundations",
      theories: [
        { author: "Piaget", concept: "Cognitive development" },
        { author: "Vygotsky", concept: "Zone of proximal development" },
        { author: "Gardner", concept: "Multiple intelligences" },
        { author: "Flavell", concept: "Metacognition" },
      ],
      principles_title: "Applied Neurocognitive Principles",
      principles: [
        "Spaced learning",
        "Cognitive load",
        "Feedback",
        "Cognitive scaffolding",
        "Zone of development",
        "Metacognition activation",
      ],
    },
    levels: {
      title: "Implementation levels",
      subtitle: "Designed for students from 4th to 11th grade",
      grades: [
        { grade: "4th", label: "Fourth" },
        { grade: "5th", label: "Fifth" },
        { grade: "6th", label: "Sixth" },
        { grade: "7th", label: "Seventh" },
        { grade: "8th", label: "Eighth" },
        { grade: "9th", label: "Ninth" },
        { grade: "10th", label: "High School" },
        { grade: "11th", label: "High School" },
      ],
      badge: "Continuous and adaptive progression",
    },
    footer: {
      slogan: "Learning Neural Network",
      tagline: "Based on pedagogical and scientific evidence",
    },
  },
};
